import styled from 'styled-components';

export const SortingWrapper = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-column-gap: 8px;
  flex-grow: 1;
`;
